var React = require('react');

function Bubbles (props) {
    return React.createElement("svg",props,[React.createElement("g",{"opacity":"0.3","key":0},React.createElement("path",{"fill":"#FFFFFF","d":"M46,55c-3.8,0.1-7.4-1-10.5-2.6l-10.7,5.8l5.8-9.6c-3.1-3.2-4.9-7.3-4.9-11.9c0-10.1,9.1-18.2,20.3-18.2\n\t\ts20.4,8.2,20.4,18.2c0,7.3-4.6,13.9-11.6,16.5C52.6,54,49.7,54.8,46,55z"})),React.createElement("g",{"opacity":"0.2","key":1},React.createElement("path",{"fill":"#FFFFFF","d":"M14.3,31.2c-3.7-3.3-6-7.9-6-12.9c0-1,0.1-2,0.3-2.9l-5.4-4.3l6.7,0.2C13,4.7,20.2,0,28.7,0\n\t\tC39.9,0,49,8.2,49,18.2c0,10.1-9.1,18.3-20.3,18.3c-3.3,0-6.3-0.8-9.1-1.9C17.4,33.7,15.8,32.6,14.3,31.2z"}))]);
}

Bubbles.defaultProps = {"version":"1.1","baseProfile":"basic","id":"Ebene_1","x":"0px","y":"0px","viewBox":"0 0 66.4 58.2","xmlSpace":"preserve"};

module.exports = Bubbles;

Bubbles.default = Bubbles;
